
import { defineComponent, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue2-helpers/vue-router'

// Components
import Loader from '@/components/Loaders/Loader.vue'

// API
import eventApi from '@/api/events'

export default defineComponent({
	name: 'TicketingQR',

	components: { Loader },

	setup() {
		// Router
		const router = useRouter()
		const route = useRoute()

		onBeforeMount(async () => await redirectToDetails())

		// Methods
		const redirectToDetails = async () => {
			const {
				params: { ticketId, subDomain, venueChainId }
			} = route

			try {
				const res = await eventApi.getInfoByTicketQRCode(
					ticketId,
					subDomain,
					venueChainId
				)

				if (!res?.data) throw new Error('No data in response')

				const {
					data: {
						eventTicket: { eventId }
					}
				} = res

				await router.push({ name: 'event-details', params: { eventId } })
			} catch (e) {
				await router.push({ name: 'notFound' })
			}
		}
	}
})
